import { ThemeToggle } from "@iluvatar/ui-kit";
import { useThemeContext } from "../../contexts/theme.provider";
export function DarkThemeToggle() {
  const { theme, setTheme } = useThemeContext();
  return <ThemeToggle theme={theme} onThemeChange={setTheme} />;
}
